import React, { useState, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import { Table } from 'reactstrap'
import moment from 'moment'

import { getChannelKey } from 'constants/channels'
import Checkbox from 'components/Checkbox'
import './styles.scss'

const Recipients = ({ users, handleSelectedUsers, fixed = false, filterType }) => {
  const [selectAll, setSelectAll] = useState(true)
  const [selectedUsers, setSelectedUsers] = useState([])
  const [excludedIds, setExcludedIds] = useState([])

  useEffect(() => {
    if (users.length) setSelectedUsers(users)
  }, [users])

  const onSelectAll = () => {
    if (selectAll) {
      setSelectAll(false)
      setSelectedUsers([])
      handleSelectedUsers([], [], false, filterType)
      const excludeUsersId = users.map((user) => user.id)
      setExcludedIds(excludeUsersId)
    } else {
      setSelectAll(true)
      setSelectedUsers(users)
      handleSelectedUsers(users, [], false, filterType)
      setExcludedIds([])
    }
  }

  const handleCheckbox = (rowId) => {
    const user = users[rowId]
    const userIndex = selectedUsers.indexOf(user)
    let newSelectedUsers = []
    let updatedExcludeIds = []

    if (userIndex !== -1) {
      // user is in selectedUsers, remove
      newSelectedUsers = [...selectedUsers]
      newSelectedUsers.splice(userIndex, 1)
      setSelectedUsers(newSelectedUsers)

      // add user.id to excludeIds
      updatedExcludeIds = [...excludedIds, user.id]

      setExcludedIds(updatedExcludeIds)

      if (selectAll) {
        setSelectAll(false)
      }
    } else {
      // user is not in selectedUsers, add
      newSelectedUsers = [].concat(selectedUsers)
      newSelectedUsers.splice(rowId, 0, user)
      setSelectedUsers(newSelectedUsers)

      // remove user.id from excludedIds
      const indexExcluded = excludedIds.indexOf(user.id)
      updatedExcludeIds = [...excludedIds]
      updatedExcludeIds.splice(indexExcluded, 1)
      setExcludedIds(updatedExcludeIds)

      if (selectAll) {
        setSelectAll(false)
      }
    }
    handleSelectedUsers(newSelectedUsers, updatedExcludeIds, false, filterType)
  }

  const renderHeaders = (users) => {
    if (users && users.length > 0) {
      const user = users[0]
      return Object.keys(user).map((key, index) => {
        if (key !== 'id' && key !== 'provider_id') {
          return <th key={index}>{I18n.t(`campaigns_${key}`)}</th>
        }
        return true
      })
    }
  }

  const renderBody = (users) => {
    if (users && users.length > 0) {
      return users.map((user, index) => {
        if (!fixed) {
          const checked = selectedUsers.indexOf(user) !== -1 ? true : false

          return (
            <tr key={index}>
              <td className="align-check">
                <Checkbox id={index} onChange={() => handleCheckbox(index)} value='true' checked={checked} />
              </td>
              {Object.keys(user).map((key, index) => {
                if (key !== 'id' && key !== 'provider_id') {
                  return (
                    <td className='text-ellipsis' key={index}>
                      {key === 'createdAt' || key === 'updatedAt'
                        ? moment(user[key]).format('DD/MM/YYYY')
                        : key === 'state'
                          ? user[key] ? I18n.t(`states_${user[key]}`) : ''
                          : key === 'channel'
                            ? user[key] ? I18n.t(`channels_${getChannelKey(user[key])}`) : ''
                            : user[key]}
                    </td>
                  )
                }
                return true
              })}
            </tr>
          )
        } else {
          return (
            <tr key={index}>
              {Object.keys(user).map((key, index) => {
                if (key !== 'id' && key !== 'provider_id') {
                  return (
                    <td className='text-ellipsis' key={index}>
                      {key === 'createdAt' || key === 'updatedAt'
                        ? user[key].length > 0
                          ? moment(user[key]).format('DD/MM/YYYY')
                          : moment().format('DD/MM/YYYY')
                        : key === 'state'
                          ? user[key] ? I18n.t(`states_${user[key]}`) : ''
                          : key === 'channel'
                            ? user[key] ? I18n.t(`channels_${getChannelKey(user[key])}`) : ''
                            : user[key]}
                    </td>
                  )
                }
                return true
              })}
            </tr>
          )
        }
      })
    }
  }

  return (
    <Table hover responsive className='table-recipients'>
      <thead>
        <tr>
          {!fixed && (
            <th className="align-check">
              <Checkbox id='checkbox' onChange={onSelectAll} value='true' checked={selectAll} />
            </th>
          )}
          {renderHeaders(users)}
        </tr>
      </thead>
      <tbody>{renderBody(users)}</tbody>
    </Table>
  )
}

export default Recipients
